import React from 'react';
import ValidationElement from '../ValidationElement';
import Radio from '../Radio';
import RadioGroup from '../RadioGroup';

export default class NameOptions extends ValidationElement {
  constructor(props) {
    super(props);

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  /**
   * Handle the change event.
   */
  handleUpdate(values) {
    this.props.onUpdate({
      name: this.props.name,
      value: values.value,
    });
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `other.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  render() {
    const selected = this.props.value;
    return (

      <RadioGroup
        className={` option-list option-list-vertical ${this.props.className || ''
        }`.trim()}
        onError={this.props.onError}
        required={this.props.required}
        selectedValue={selected}
        attribute={this.props.attribute}
      >
        <Radio
          name="maiden-name"
          label="Name prior to marriage"
          value="Name prior to marriage"
          className="Name-prior-to-marriage"
          disabled={this.props.disabled}
          readonly={this.props.readonly}
          required={this.props.required}
          onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError}
        />
        <Radio
          name="maiden-name"
          label="Former married name"
          value="Former married name"
          className="Former-married-name"
          disabled={this.props.disabled}
          readonly={this.props.readonly}
          required={this.props.required}
          onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError}
        />
        <Radio
          name="maiden-name"
          label="Nickname"
          value="Nickname"
          className="Nickname"
          disabled={this.props.disabled}
          readonly={this.props.readonly}
          required={this.props.required}
          onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError}
        />
        <Radio
          name="maiden-name"
          label="Alias"
          value="Alias"
          className="Alias"
          disabled={this.props.disabled}
          readonly={this.props.readonly}
          required={this.props.required}
          onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError}
        />
        <Radio
          name="maiden-name"
          label="Former legal name"
          value="Former legal name"
          className="Former-legal-name"
          disabled={this.props.disabled}
          readonly={this.props.readonly}
          required={this.props.required}
          onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError}
        />
        <Radio
          name="maiden-name"
          label="Other"
          value="Other"
          className="Other"
          disabled={this.props.disabled}
          readonly={this.props.readonly}
          required={this.props.required}
          onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError}
        />

      </RadioGroup>

    );
  }
}
NameOptions.defaultProps = {
  value: '',
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};

NameOptions.errors = [];
